import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { mediaUrl, baseURL } from "../axiosInterceptor/axiosInterceptorC";

// Fetch user details
export const fetchUserDetails = createAsyncThunk(
  'user/fetchUserDetails',
  async (login_id, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseURL}/fetchuserdetailsid`, { login_id });
      console.log(response.data)
      return {
        userDetails: response.data.userdetails[0],
        alternativeNum: response.data.alternativenum || [],
        personalDetails: response.data.personaldetails[0] || {},
      };
      
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching user details");
    }
  }
);

// Fetch property details
export const fetchPropertyDetails = createAsyncThunk(
  'user/fetchPropertyDetails',
  async ({ login_id, Pstatus }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseURL}/fetchPropertyDetails_get`, {
        login_id: login_id,
        Pstatus: Pstatus,
      });
      return {
        completed: response.data.completedCount[0]?.total_properties || 0,
        pending: response.data.pendingdCount[0]?.total_properties || 0,
        inactive: response.data.inactivecount[0]?.total_properties || 0,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching property details");
    }
  }
);

const initialState = {
  userDetails: null,
  personalDetails: {},
  alternativeNum: [],
  isPlaceCheck: false,
  selectedRole: '',
  phoneNumbers1: [],
  CompletedProperties: 0,
  PendingProperties: 0,
  inactiveProperties: 0,
  loading: false,
  error: null,
  gettokenval: localStorage.getItem("jwtToken"),
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetUserState: (state) => {
      return {
        ...initialState,
        gettokenval: null, // Ensure token is removed from Redux state
      };
    },
    setTokengen: (state, action) => {
      state.gettokenval = action.payload; // Update token in Redux state
    }

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { userDetails, alternativeNum, personalDetails } = action.payload;
        state.userDetails = userDetails;
        state.personalDetails = personalDetails;
        state.alternativeNum = alternativeNum;
        state.selectedRole = userDetails.role_val;
        state.isPlaceCheck = userDetails.role_val === "Agent";
        state.phoneNumbers1 = Array.isArray(alternativeNum) 
    ? alternativeNum.map(item => ({ id: item.id, phone_number: item.phone_number.toString() })) 
    : [];
      })
      .addCase(fetchUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchPropertyDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPropertyDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.CompletedProperties = action.payload.completed;
        state.PendingProperties = action.payload.pending;
        state.inactiveProperties = action.payload.inactive;
      })
      .addCase(fetchPropertyDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});


export const { resetUserState,setTokengen } = userSlice.actions;
export default userSlice.reducer;
